import { render, staticRenderFns } from "./checkTopics.vue?vue&type=template&id=56bacaeb&scoped=true&"
import script from "./checkTopics.vue?vue&type=script&lang=js&"
export * from "./checkTopics.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/newTopic/checkInterviews.less?vue&type=style&index=0&id=56bacaeb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bacaeb",
  null
  
)

component.options.__file = "checkTopics.vue"
export default component.exports